/* Tournament Calendar — renders a themed month calendar + an "upcoming" list from
   the JSON tournament data emitted by sections/tournament-calendar.liquid. Pure
   vanilla JS, no dependencies. Each [data-tournament-calendar] section is wired
   independently. */
(function () {
  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function parseDate(str) {
    /* forgiving: accepts 2026-07-21 AND 2026-7-21 — a merchant typo used to make
       the event silently vanish from the page */
    if (!str || !/^\d{4}-\d{1,2}-\d{1,2}$/.test(str.trim())) return null;
    var p = str.trim().split('-');
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return isNaN(d.getTime()) ? null : d;
  }
  function ymd(d) { return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); }
  function todayMidnight() {
    /* the store's calendar day (LA), not the viewer's — otherwise events drop off
       early for anyone east of Pacific time */
    try {
      var la = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles' }).format(new Date());
      var d = parseDate(la);
      if (d) return d;
    } catch (e) { /* ancient browser: fall through to viewer-local */ }
    var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }
  function fmtLong(d) {
    return WEEKDAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()].slice(0, 3) + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function normalize(raw) {
    var list = [];
    (raw || []).forEach(function (t) {
      var start = parseDate(t.date);
      if (!start) return;
      var end = parseDate(t.endDate) || start;
      if (ymd(end) < ymd(start)) end = start;
      list.push({
        id: t.id, title: t.title || 'Tournament', game: t.game || '', color: t.color || '#7b2cff',
        start: start, end: end, time: t.time || '', location: t.location || '', format: t.format || '',
        cost: t.cost || '', signupUrl: t.signupUrl || '', signupLabel: t.signupLabel || 'Check availability',
        details: t.details || ''
      });
    });
    list.sort(function (a, b) { return ymd(a.start) - ymd(b.start); });
    return list;
  }

  function eventsOnDay(list, dayNum) {
    return list.filter(function (t) { return ymd(t.start) <= dayNum && dayNum <= ymd(t.end); });
  }

  // ---- Grouped cards: sessions of the SAME tournament (same title + game, e.g.
  // Burbank + Glendale dates) share ONE card, each session keeping its own date,
  // location, time, and status row. ----
  function groupKey(t) {
    return (t.title + '|' + t.game).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function groupUpcoming(upcoming) {
    var groups = [];
    var byKey = {};
    upcoming.forEach(function (t) {
      var k = groupKey(t);
      if (!byKey[k]) {
        byKey[k] = { title: t.title, game: t.game, color: t.color, sessions: [] };
        groups.push(byKey[k]);
      }
      byKey[k].sessions.push(t);
    });
    // groups keep the order of their earliest session (upcoming is date-sorted)
    return groups;
  }

  function sharedValue(sessions, prop) {
    var v = sessions[0][prop];
    for (var i = 1; i < sessions.length; i++) if (sessions[i][prop] !== v) return '';
    return v;
  }

  function sessionRowHTML(t, sharedFormat, sharedCost, perSessionLinks) {
    var when = WEEKDAYS[t.start.getDay()];
    if (ymd(t.end) !== ymd(t.start)) {
      when = 'thru ' + MONTHS[t.end.getMonth()].slice(0, 3) + ' ' + t.end.getDate();
    }
    if (t.time) when += ' · ' + esc(t.time);

    var chips = ['<span class="tcal__chip">' + when + '</span>'];
    if (t.location) chips.push('<span class="tcal__chip">' + esc(t.location) + '</span>');
    // format/cost usually match across sessions and live on the card header —
    // only a session that DIFFERS shows its own value here
    if (t.format && t.format !== sharedFormat) chips.push('<span class="tcal__chip">' + esc(t.format) + '</span>');
    if (t.cost && t.cost !== sharedCost) chips.push('<span class="tcal__chip tcal__chip--cost">' + esc(t.cost) + '</span>');
    // when the group's sessions point at DIFFERENT signup pages, each row gets its own link
    if (perSessionLinks && t.signupUrl) {
      chips.push('<a class="tcal__chip tcal__chip--link" href="' + esc(t.signupUrl) + '" target="_blank" rel="noopener">' + esc(t.signupLabel) + ' ↗</a>');
    }

    // screen readers get the full date (the visual date tile is aria-hidden)
    var srDate = fmtLong(t.start);
    if (ymd(t.end) !== ymd(t.start)) srDate += ' through ' + fmtLong(t.end);

    return '' +
      '<div class="tcal__session">' +
        '<span class="visually-hidden">' + srDate + '</span>' +
        '<span class="tcal__sdate" aria-hidden="true">' +
          '<span class="tcal__sdate-mon">' + MONTHS[t.start.getMonth()].slice(0, 3).toUpperCase() + '</span>' +
          '<span class="tcal__sdate-day">' + t.start.getDate() + '</span>' +
        '</span>' +
        '<span class="tcal__session-chips">' + chips.join('') + '</span>' +
      '</div>';
  }

  function groupCardHTML(g, hero) {
    var sessions = g.sessions;
    var sharedFormat = sharedValue(sessions, 'format');
    var sharedCost = sharedValue(sessions, 'cost');

    var headChips = [];
    if (sharedFormat) headChips.push('<span class="tcal__chip">' + esc(sharedFormat) + '</span>');
    if (sharedCost) headChips.push('<span class="tcal__chip tcal__chip--cost">' + esc(sharedCost) + '</span>');

    // one "Check availability" button per card when every session shares a signup
    // locator; if sessions point at DIFFERENT pages, each session row links itself.
    var withLink = sessions.filter(function (t) { return t.signupUrl; });
    var uniqueUrls = [];
    withLink.forEach(function (t) { if (uniqueUrls.indexOf(t.signupUrl) === -1) uniqueUrls.push(t.signupUrl); });
    var perSessionLinks = uniqueUrls.length > 1;
    var cta = '';
    if (withLink.length && !perSessionLinks) {
      cta = '<a class="tcal__btn button" href="' + esc(withLink[0].signupUrl) + '" target="_blank" rel="noopener">' + esc(withLink[0].signupLabel) + ' ↗</a>';
    }

    var rows = sessions.map(function (t) { return sessionRowHTML(t, sharedFormat, sharedCost, perSessionLinks); }).join('');

    // merchant "Extra details" (12-player caps, pay-in-person notes…) were invisible
    // before — surface the group's unique details in a collapsed row
    var detailHtml = '';
    var seenDetails = [];
    sessions.forEach(function (t) {
      var dt = (t.details || '').trim();
      if (dt && seenDetails.indexOf(dt) === -1) seenDetails.push(dt);
    });
    if (seenDetails.length) {
      detailHtml = '<details class="tcal__more"><summary>More info</summary><div class="tcal__more-body">' + seenDetails.join('') + '</div></details>';
    }

    return '' +
      '<article class="tcal__card tcal__card--group' + (hero ? ' tcal__card--hero' : '') + '" style="--tcal-accent:' + esc(g.color) + ';">' +
        '<div class="tcal__card-body">' +
          '<div class="tcal__card-top">' +
            (hero ? '<span class="tcal__upnext">Up next</span>' : '') +
            (g.game ? '<span class="tcal__game" style="--tcal-accent:' + esc(g.color) + ';">' + esc(g.game) + '</span>' : '') +
            headChips.join('') +
          '</div>' +
          '<h4 class="tcal__card-title">' + esc(g.title) + '</h4>' +
          '<div class="tcal__sessions">' + rows + '</div>' +
          detailHtml +
          (cta ? '<div class="tcal__card-cta">' + cta + '</div>' : '') +
        '</div>' +
      '</article>';
  }

  // Render an upcoming list: same-tournament sessions combined into one card, the
  // first group highlighted as the "Up next" hero, the rest in a grid.
  function upcomingHTML(upcoming) {
    var groups = groupUpcoming(upcoming);
    if (!groups.length) return '';
    var html = groupCardHTML(groups[0], true);
    if (groups.length > 1) {
      html += '<div class="tcal__rest">' + groups.slice(1).map(function (g) { return groupCardHTML(g); }).join('') + '</div>';
    }
    return html;
  }

  // Staggered scroll-in animation for the cards (skipped for reduced-motion users
  // and browsers without IntersectionObserver — cards just render visible).
  function animateCards(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(scope.querySelectorAll('.tcal__card'), function (c, i) {
      c.classList.add('tcal__card--anim');
      c.style.setProperty('--tcal-in-delay', Math.min(i * 70, 420) + 'ms');
      io.observe(c);
    });
  }

  function init(root) {
    var dataEl = root.querySelector('[data-tournaments]');
    var calEl = root.querySelector('[data-calendar]');
    var listEl = root.querySelector('[data-list]');
    if (!dataEl) return;
    var list;
    try { list = normalize(JSON.parse(dataEl.textContent)); } catch (e) { return; }

    // No tournaments added yet — show a clean "coming soon" state and hide the calendar.
    if (!list.length) {
      root.classList.add('tcal--empty-all');
      if (calEl) calEl.style.display = 'none';
      if (listEl) {
        listEl.innerHTML = '<div class="tcal__coming"><h3>Tournaments coming soon</h3>' +
          '<p>Our events run on short notice — the moment a game rep confirms a date, it will appear here with all the details and a sign-up link. Check back soon, or ask us in store.</p></div>';
      }
      return;
    }

    var weekStart = root.getAttribute('data-week-start') === '1' ? 1 : 0;
    var today = todayMidnight();
    var todayNum = ymd(today);

    // Default month = month of the next upcoming event, else current month.
    var upcoming = list.filter(function (t) { return ymd(t.end) >= todayNum; });
    var anchor = upcoming.length ? upcoming[0].start : today;
    var view = { y: anchor.getFullYear(), m: anchor.getMonth() };
    var selectedNum = null;

    function renderList() {
      if (!listEl) return;
      if (!upcoming.length) {
        listEl.innerHTML = '<div class="tcal__empty"><p>No tournaments on the calendar right now.</p>' +
          '<p class="tcal__empty-sub">Our events drop on short notice the moment a rep reaches out — check back soon or follow us in store.</p></div>';
        return;
      }
      listEl.innerHTML = upcomingHTML(upcoming);
      animateCards(listEl);
    }

    function renderSelected() {
      var panel = calEl.querySelector('[data-selected]');
      if (!panel) return;
      if (selectedNum == null) { panel.innerHTML = ''; panel.hidden = true; return; }
      var evs = eventsOnDay(list, selectedNum);
      if (!evs.length) { panel.innerHTML = ''; panel.hidden = true; return; }
      panel.hidden = false;
      panel.innerHTML = evs.map(function (t) {
        return groupCardHTML({ title: t.title, game: t.game, color: t.color, sessions: [t] });
      }).join('');
    }

    function renderCalendar() {
      var first = new Date(view.y, view.m, 1);
      var startWeekday = first.getDay();
      var lead = (startWeekday - weekStart + 7) % 7;
      var daysInMonth = new Date(view.y, view.m + 1, 0).getDate();
      var totalCells = Math.ceil((lead + daysInMonth) / 7) * 7;

      var labels = '';
      for (var w = 0; w < 7; w++) labels += '<div class="tcal__dow">' + WEEKDAYS[(weekStart + w) % 7] + '</div>';

      var cells = '';
      for (var i = 0; i < totalCells; i++) {
        var dayNo = i - lead + 1;
        if (dayNo < 1 || dayNo > daysInMonth) { cells += '<div class="tcal__cell tcal__cell--empty"></div>'; continue; }
        var cellNum = view.y * 10000 + (view.m + 1) * 100 + dayNo;
        var evs = eventsOnDay(list, cellNum);
        var cls = 'tcal__cell';
        if (cellNum === todayNum) cls += ' tcal__cell--today';
        if (cellNum === selectedNum) cls += ' tcal__cell--selected';
        if (cellNum < todayNum) cls += ' tcal__cell--past';
        if (evs.length) {
          cls += ' tcal__cell--event';
          var dots = '';
          evs.slice(0, 3).forEach(function (e) { dots += '<span class="tcal__dot" style="background:' + esc(e.color) + ';"></span>'; });
          cells += '<button type="button" class="' + cls + '" data-day="' + cellNum + '" aria-label="' + evs.length + ' tournament(s) on ' + MONTHS[view.m] + ' ' + dayNo + '">' +
            '<span class="tcal__num">' + dayNo + '</span><span class="tcal__dots">' + dots + '</span></button>';
        } else {
          cells += '<div class="' + cls + '"><span class="tcal__num">' + dayNo + '</span></div>';
        }
      }

      calEl.innerHTML =
        '<div class="tcal__head">' +
          '<button type="button" class="tcal__nav" data-prev aria-label="Previous month">‹</button>' +
          '<div class="tcal__month">' + MONTHS[view.m] + ' ' + view.y + '</div>' +
          '<button type="button" class="tcal__nav" data-next aria-label="Next month">›</button>' +
        '</div>' +
        '<div class="tcal__grid tcal__grid--dow">' + labels + '</div>' +
        '<div class="tcal__grid tcal__grid--days">' + cells + '</div>' +
        '<div class="tcal__selected" data-selected hidden></div>';

      calEl.querySelector('[data-prev]').addEventListener('click', function () { step(-1); });
      calEl.querySelector('[data-next]').addEventListener('click', function () { step(1); });
      Array.prototype.forEach.call(calEl.querySelectorAll('[data-day]'), function (btn) {
        btn.addEventListener('click', function () {
          var n = +btn.getAttribute('data-day');
          selectedNum = (selectedNum === n) ? null : n;
          renderCalendar();
          renderSelected();
          var panel = calEl.querySelector('[data-selected]');
          if (selectedNum != null && panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
      renderSelected();
    }

    function step(delta) {
      var m = view.m + delta;
      view.y += Math.floor(m / 12);
      view.m = ((m % 12) + 12) % 12;
      selectedNum = null;
      renderCalendar();
    }

    if (calEl) renderCalendar();
    renderList();
  }

  // Per-game tournament pages: the events live ONCE on the main tournaments page
  // (single source of truth) — a game page fetches that page's embedded JSON and
  // renders only its own game's events with the same cards. Add a tournament on
  // the main calendar and every game page updates itself.
  function normKey(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function initGame(root) {
    var listEl = root.querySelector('[data-game-list]');
    if (!listEl) return;
    var key = normKey(root.getAttribute('data-game'));
    var emptyText = root.getAttribute('data-empty') || 'No tournaments on the calendar right now.';
    function showEmpty() {
      root.classList.add('tcal--empty-all');
      listEl.innerHTML = '<div class="tcal__empty"><p>' + esc(emptyText) + '</p>' +
        '<p class="tcal__empty-sub">Our events drop on short notice the moment a rep reaches out — check back soon or ask us in store.</p></div>';
    }
    fetch(root.getAttribute('data-source') || '/pages/details')
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var dataEl = doc.querySelector('[data-tournaments]');
        var list = normalize(JSON.parse(dataEl ? dataEl.textContent : '[]'));
        var todayNum = ymd(todayMidnight());
        var upcoming = list.filter(function (t) {
          if (ymd(t.end) < todayNum) return false;
          return key && (normKey(t.game).indexOf(key) !== -1 || normKey(t.title).indexOf(key) !== -1);
        });
        if (!upcoming.length) { showEmpty(); return; }
        listEl.innerHTML = upcomingHTML(upcoming);
        animateCards(listEl);
      })
      .catch(showEmpty);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tournament-calendar]'), init);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tournament-game]'), initGame);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
